import { gsap } from "gsap";
import hoverintent from "hoverintent";



// Throttle Function
const throttle = (func, delay) => {
    let inProgress = false;
    return (...args) => {
        if (inProgress) {
            return;
        }
        inProgress = true;
        setTimeout(() => {
            func(...args);
            inProgress = false;
        }, delay);
    };
};



// Mobile Navigation Toggle
const $bodyElement = document.querySelector('body');
const $navigationOpenElement = document.querySelector('[navigation-toggle]');
const $navigationCloseElement = document.querySelector('[navigation-close]');
const $siteNavigationElement = document.querySelector('[navigation-container]');
const $siteNavigationElementShadow = $siteNavigationElement.querySelector('.siteNavigation__shadow');

$navigationOpenElement.addEventListener("click", (e) => toggleNavigation());
$navigationCloseElement.addEventListener("click", (e) => toggleNavigation());

function toggleNavigation()
{
    const tlNavigation = gsap.timeline().timeScale(1);
    
    if ($bodyElement.classList.contains('navigation--open'))
    {
        const subNavPanels = document.querySelectorAll('.subNav--visible');

        [...subNavPanels].forEach((element, index) => {
            element.classList.remove('subNav--visible');
        });

        $bodyElement.classList.add('navigation--closing');

        // Slide off
        tlNavigation.add('start');
        tlNavigation.to($siteNavigationElementShadow, {duration: 1, ease: "expo.inOut", opacity: 0}, 'start');
        tlNavigation.to($siteNavigationElement, {duration: 1, ease: "expo.inOut", x: "100%", onComplete: function() {
            $bodyElement.classList.remove('navigation--open');
            $bodyElement.classList.remove('navigation--closing');
        }}, 'start');
    }
    else
    {
        $bodyElement.classList.add('navigation--open');
        $bodyElement.classList.add('navigation--opening');

        // Slide on
        tlNavigation.add('start');
        tlNavigation.to($siteNavigationElementShadow, {duration: 0.8, ease: "expo.inOut", opacity: 1}, 'start');
        tlNavigation.to($siteNavigationElement, {duration: 0.8, ease: "expo.inOut", x: "10%", onComplete: function() {
            $bodyElement.classList.remove('navigation--opening');
        }}, 'start');
    }
}



// Sub Nav Hover
const windowTargetSize = 870;
let enableHoverFeature = false;

const handleNavResize = throttle(() => {
    const viewportSize = document.querySelector('body').clientWidth;

    if (viewportSize >= windowTargetSize)
    {
        enableHoverFeature = true;
    }
    else
    {
        enableHoverFeature = false;
    }
}, 100);

window.addEventListener("resize", handleNavResize);
handleNavResize();

const navItemsWithChildren = document.querySelectorAll('.menu-item-has-children');

if (navItemsWithChildren.length > 0)
{
    [...navItemsWithChildren].forEach((element, index) => {
        
        // Desktop Hovers
        hoverintent(element,
            () => {
                if (enableHoverFeature)
                {
                    element.classList.add('subNav--visible');
                }
            },
            () => {
                if (enableHoverFeature)
                {
                    element.classList.remove('subNav--visible');
                }
            }
        ).options({timeout: 200});

        // Mobile Arrows
        const buttonForward = element.querySelector('[navigation-forward]');
        const buttonBackward = element.querySelector('[navigation-back]');

        buttonForward.addEventListener("click", (e) => {
            element.classList.add('subNav--visible');

            e.preventDefault();
            e.stopImmediatePropagation();
        });

        buttonBackward.addEventListener("click", (e) => {
            element.classList.remove('subNav--visible');
        });
    });
}